import React from 'react';
import clsx from 'clsx';

interface ModalFooterProps {
  children: React.ReactNode;
  className?: string;
  align?: 'left' | 'center' | 'right' | 'space-between';
}

const alignClasses = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
  'space-between': 'justify-between',
};

export function ModalFooter({ children, className, align = 'right' }: ModalFooterProps) {
  return (
    <div className={clsx('modal-footer flex', alignClasses[align], className)}>
      {children}
    </div>
  );
}
